if (!customElements.get('mds-product-stock')) {
  customElements.define('mds-product-stock', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-page') || this.closest('.shopify-section');
      this.onVariantChange = event => {
        if (!event.target.matches('product-variants[data-main-product-variants]')) return;
        this.showVariant(event.target.currentVariant?.id);
      };
      this.onFormChange = event => {
        if (event.target.name === 'id') this.showVariant(event.target.value);
      };
      this.scope?.addEventListener('VARIANT_CHANGE', this.onVariantChange, true);
      this.scope?.addEventListener('change', this.onFormChange);
      const picker = this.scope?.querySelector('product-variants[data-main-product-variants]');
      if (picker?.currentVariant) this.showVariant(picker.currentVariant.id);
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('VARIANT_CHANGE', this.onVariantChange, true);
      this.scope?.removeEventListener('change', this.onFormChange);
    }
    showVariant(id) {
      const template = [...this.querySelectorAll('template[data-stock-variant]')]
        .find(item => item.dataset.stockVariant === String(id));
      const current = this.querySelector('[data-stock-current]');
      if (!current) return;
      this.hidden = !template;
      if (!template || this.dataset.selectedVariant === String(id)) return;
      current.replaceChildren(template.content.cloneNode(true));
      this.dataset.selectedVariant = String(id);
    }
  });
}
